import {
  date, nullable, number, string,
} from '@sda/sdk/helpers/types.bitmasks';

export const PublicLinkMask = {
  createdAt: date,
  updatedAt: date,

  slug: string | nullable,
  slugLowercase: string | nullable,
  numImpressions: number,
  target: string | nullable,
  targetId: string | nullable,
  utmSource: string,
  utmCampaign: string | nullable,
  utmContent: string | nullable,
  utmMedium: string | nullable,
};
